<template lang="pug">
redesign-dialog(
  v-model="showDialog"
  width="560"
  @close="cancelHandler"
)
  .pa-5(v-if="!showResult")
    .d-flex.justify-space-between
      p.title.font-weight-bold {{ title }}
      v-btn.ml-auto(
        icon
        @click="cancelHandler"
      ): v-icon(size="22") mdi-close
    .text-center.my-8
      p.title.mb-2 {{ message }}
      slot
    slot(name="additional")
    .d-flex.justify-space-between.gap-16.px-2
      app-button.rounded-12.flex-1(
        outlined
        min-width="200"
        :height="48"
        @click="cancelHandler"
      ) {{ cancelText }}
      app-button.rounded-12.flex-1(
        min-width="200"
        :height="48"
        :loading="loading"
        @click="acceptClickHandler"
      ) {{ acceptText }}
  .pa-5(v-else)
    .d-flex.justify-space-between
      //- p.title.font-weight-bold {{ title }}
      v-btn.ml-auto(
        icon
        @click="cancelHandler"
      ): v-icon(size="22") mdi-close
    .text-center.my-8
      v-icon.mb-8(
        :color="resultIconColor"
        size="56"
      ) {{ resultIcon }}
      p.title {{ resultMessage }}
    .text-center
      app-button(
        width="240"
        :height="48"
        @click="cancelHandler"
      ) {{ resultButtonText }}
</template>

<script>
import RedesignDialog from './RedesignDialog.vue';
import AppButton from '../controls/AppButton.vue';

export default {
  name: 'RedesignConfirmDialog',

  components: {
    RedesignDialog,
    AppButton,
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    acceptHandler: {
      type: Function,
      default: () => {},
    },
    cancelHandler: {
      type: Function,
      default: () => {},
    },
    acceptText: {
      type: String,
      default: 'Подтвердить',
    },
    cancelText: {
      type: String,
      default: 'Отменить',
    },
    title: {
      type: String,
      default: 'Подтвердите действие',
    },
    message: {
      type: String,
      default: '',
    },
    resultIcon: {
      type: String,
      default: '$icheck-outline-circle',
    },
    resultIconColor: {
      type: String,
      default: 'redesignSuccess',
    },
    resultMessage: {
      type: String,
      default: 'Успешно',
    },
    resultButtonText: {
      type: String,
      default: 'Вернуться',
    },
    isServerResponse: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      loading: false,
      showResult: false,
    };
  },

  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
  },

  watch: {
    showDialog(v) {
      if (!v) {
        this.showResult = false;
        this.loading = false;
      }
    },
  },

  methods: {
    async acceptClickHandler() {
      if (!this.isServerResponse) {
        this.acceptHandler();
        return;
      }
      this.loading = true;
      await this.$rHandler(this.acceptHandler(), (response) => {
        this.$emit('accept-success', response);
        this.showResult = true;
      });
      this.loading = false;
    },
  },
};
</script>
